// extracted by mini-css-extract-plugin
export default {"button":"InvitesHeader_button__sMbsr","header":"InvitesHeader_header__mlYRl","description":"InvitesHeader_description__MZtQp"};